import { UrlSegment, UrlSegmentGroup } from '@angular/router';
import { SelectedGeolocation } from '../../../../shared/models/v2/search';
import { UrlBuilderParams } from '../url-builder-params';
import '../../string-prototypes';
import { getCityAndStateSegment } from '../url-helpers';

export abstract class FalUrlBuilderStrategy {
  private segments: UrlSegment[] = [];

  abstract shouldBuild(urlBuilderParams: UrlBuilderParams): boolean;
  abstract createUrlSegments(urlBuilderParams: UrlBuilderParams): void;

  addSegments(...newSegments: string[]): void {
    const items: UrlSegment[] = newSegments.map((s) => {
      const urlSegment = new UrlSegment(s.toUrlFriendly().trimTrailingForwardSlash(), {});
      return urlSegment;
    });
    this.segments.push(...items);
  }

  addCityAndStateSegment(selectedGeolocation: SelectedGeolocation | null): void {
    const cityAndStateSegment = getCityAndStateSegment(selectedGeolocation);
    this.addSegments(cityAndStateSegment);
  }

  build(urlBuilderParams: UrlBuilderParams, baseUrl = ''): string {
    this.segments = [];

    this.createUrlSegments(urlBuilderParams);

    const url: string = new UrlSegmentGroup(this.segments, {}).toString().trimTrailingForwardSlash();
    if (baseUrl) {
      baseUrl = baseUrl.trimTrailingForwardSlash();
      // url already starts with a forward slash.
      return `${baseUrl}${url}`;
    }
    return url;
  }

  SerachbuildData(urlBuilderParams: UrlBuilderParams, baseUrl = ''): string {
    this.segments = [];

    this.createUrlSegments(urlBuilderParams);

    const url: string = new UrlSegmentGroup(this.segments, {}).toString().trimTrailingForwardSlash();
    if (baseUrl) {
      baseUrl = baseUrl.trimTrailingForwardSlash();
      // url already starts with a forward slash.
      return `${baseUrl}${url}`;
    }
    return url;
  }

  hasGeolocationData(urlBuilderParams: UrlBuilderParams): boolean {
    return (
      (!!urlBuilderParams.selectedGeolocation?.city && !!urlBuilderParams.selectedGeolocation?.state) ||
      !!urlBuilderParams.selectedGeolocation?.name
    );
  }
}
